import { render } from "./vacancySlider.vue?vue&type=template&id=145a2dce&scoped=true"
import script from "./vacancySlider.vue?vue&type=script&lang=js"
export * from "./vacancySlider.vue?vue&type=script&lang=js"

import "./vacancySlider.vue?vue&type=style&index=0&id=145a2dce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145a2dce"]])

export default __exports__